import { render, staticRenderFns } from "./leader.vue?vue&type=template&id=bfafbfe8&scoped=true&"
import script from "./leader.vue?vue&type=script&lang=js&"
export * from "./leader.vue?vue&type=script&lang=js&"
import style0 from "./leader.vue?vue&type=style&index=0&id=bfafbfe8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfafbfe8",
  null
  
)

export default component.exports